<template>
  <section class="c-section c-section--404">
    <div class="container py-5">
      <h1 class="c-section-content-title text-center pri-color w-sbold mb-3">
        Error 404
      </h1>
      <div class="c-section-content c-section-content--normal position-relative mb-5">
        <p class="m-0 text-center">Página no encontrada</p>
      </div>
      <div class="d-flex justify-content-center pt-3 mb-2">
        <figure class="c-pic">
          <img src="@/assets/images/404.png" alt="">
        </figure>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      context: {},
    };
  },
};
</script>
